import * as React from "react";

import {CarGrid} from "../offer/detail/components/car_box/CarGrid";
import {SearchBar} from "../search/SearchBar";
import {BrowseCarsSection} from "./components/BrowseCarsSection";
import {CarBrandsSection} from "./components/CarBrandsSection";
import {HeroSection} from "./components/HeroSection";
import {HomepageSeoIndex} from "./components/HomepageSeoIndex";
import {SeasonalOffer} from "./components/SeasonalOffer";

export const HomepageDynamic = () => {
    return (
        <>
            <HeroSection />
            <SearchBar />
            <CarBrandsSection />
            <BrowseCarsSection />
            <SeasonalOffer />
            <CarGrid />
            <HomepageSeoIndex />
        </>
    );
};
